let Contracts = {
  SmartCityContract: "0xcaE4fB5cdA5f679c6dB7A7A4b2b08F1A4E6b59Ac",
  ValidatorContract: "0x4893BcBd599daf621dc39f08A469079b272D81A5",
};

export default Contracts;
